import { render, staticRenderFns } from "./ProductFooter.vue?vue&type=template&id=423ffbf0&scoped=true&"
import script from "./ProductFooter.vue?vue&type=script&lang=js&"
export * from "./ProductFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProductFooter.vue?vue&type=style&index=0&id=423ffbf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ffbf0",
  null
  
)

export default component.exports